import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss']
})
export class PaginationComponent {
  @Input() page: number;
  @Input() pageSize: number;
  private _total: number;
  @Input() public set total(value: number) {
    this._total = value;
    const pages = Math.floor(this.total / this.pageSize);
    this.pagesTotal = pages * this.pageSize === this.total ? pages : pages + 1;
  }
  @Input() onTop: boolean;
  public get total(): number {
    return this._total;
  }
  @Output() pageChange: EventEmitter<number> = new EventEmitter<number>();

  public pagesTotal = 0;

  constructor() {}

  public get pageItems(): string[] {
    const items: string[] = [];
    for (let i = 1; i <= this.pagesTotal; i++) {
      if ((this.pagesTotal <= 3) || (i === 1 && this.page > 1)) {
        items.push(i.toString());
      } else if (i === 2 && this.page > 3) {
        items.push('...');
      } else if (i >= (this.page >= this.pagesTotal - 1 ? this.pagesTotal - 2 : this.page - 1)
        && i <= (this.page > 2 ? this.page + 1 : 3)) {
        items.push(i.toString());
      } else if (i === (this.pagesTotal - 1) && this.page < (this.pagesTotal - 2)) {
        items.push('...');
      } else if (i === this.pagesTotal && this.page < this.pagesTotal - 1) {
        items.push(this.pagesTotal.toString());
      }
    }
    return items;
  }
}
